// import styled from 'styled-components';
import { Button } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

const ButtonGZ = withStyles({
  root: {
    backgroundColor: 'var(--tertiary-color)',
    '& ': {
      backgroundColor: `${props =>
        props.variant === 'main' ? 'var(--yellow-highlight)' : 'var(--tertiary-color)'}`
    },
    fontFamily: 'Montserrat',
    fontSize: '12px',
    fontWeight: 700,
    fontStyle: 'normal',
    lineHeight: '36px',
    letterSpacing: 0,
    textAlign: 'center',
    color: 'var(--primary-color)',
    borderRadius: '2px',
    padding: 'inherit 15px',
    margin: '4px',
    boxShadow: '4px 4px 0px var(--primary-color)',
    transition: 'all 0.2s',
    bottom: 0,
    '&:hover, &:active': {
      boxShadow: '1px 1px 0px var(--primary-color)',
      backgroundColor: 'var(--yellow-highlight)',
      bottom: '-3px'
    },
    '&:focus': {
      boxShadow: '2px 2px 0px var(--primary-color)',
      outline: 'none',
      bottom: '-2px'
    }
  },
  label: {
    textTransform: 'uppercase'
  }
})(Button)

export default ButtonGZ
